import React, { FunctionComponent } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { renderExternalLinksTable } from './CatalogPage';

export const SimpleCatalogPage: FunctionComponent = () => {
  const externalLinksData = [
    { name: 'RECY ONLINE API - DEV', link: 'http://80.120.126.203:4453/RecyOnline.API/api-docs/index.html' },
    { name: 'RECY Import / Export - DEV', link: 'http://80.120.126.203:4453/bulk-import-export/api-docs/index.html' },
    { name: 'RECY businessprocesses - DEV', link: 'http://80.120.126.203:4453/businessprocesses/api-docs/index.html' },
    { name: 'RONA API', link: 'https://rona.loacker.cc:48003/ContecMobile/?wsdl' },
    { name: 'KENDOX', link: 'http://ATGOLOS220/InfoShare' },
    { name: 'Kunden Portal Dev', link: 'https://loacker-kundenportal.denovo.cloud/portal/container-overview' },
    { name: 'Kunden Portal', link: 'https://kundenportal.loacker.cc/login' },
    { name: 'Mongo DB', link: 'https://cloud.mongodb.com/v2/5f9bd7bca5436a13f75b2c3a#clusters' },
    { name: 'WIKI - on 192.168.66.206', link: 'https://wiki.genesiscloud.cc/de/home' },
    { name: 'Adino', link: 'https://srv280.adino.at:8443/login_up.php?success_redirect_url=%2Fsmb%2Fweb%2Fview' },
    { name: 'Slock Sensors', link: 'https://swc.sloc.one/login' },
    { name: 'Infeo', link: 'https://awm.infeo.at/de/login' },
    { name: 'Wordpress Loacker', link: 'https://loacker-recycling.com/at/' },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={4} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>External Links</Typography>
        {renderExternalLinksTable(externalLinksData)}
      </Paper>
    </Box>
  );
};

export default SimpleCatalogPage;
